import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { cardApi } from './cardApi'
import counterReducer from "./slices/pageSlice"
import userReducer from "./slices/userSlice"

export const store = configureStore({
    reducer: {
        page: counterReducer,
        user: userReducer,
        [cardApi.reducerPath]: cardApi.reducer,
    },
    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(cardApi.middleware),
})

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)